<template>
  <div style="width:100%">
    <a-row :gutter="[24, 8]">
      <a-col :span="8">
        <a-form-item label="公证费" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
          <a-input-group compact>
            <a-input-number 
              v-decorator="[
                'notarizationPrice',
                {
                  rules: [{ required: true, message: '请输入' }],
                },
              ]"
              :min="0"
              placeholder="请输入公证费"
              style="width: 80%"
            />
            <div style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center">元</div>
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="副本费" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
          <a-input-group compact>
            <a-input-number 
              v-decorator="[
                'duplicationPrice',
                {
                  rules: [{ required: true, message: '请输入' }],
                },
              ]"
              :min="0"
              style="width: 80%"
            />
            <div style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center">元</div>
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="服务费" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
          <a-input-group compact>
            <a-input-number 
              v-decorator="[
                'servicePrice',
                {
                  rules: [{ required: true, message: '请输入' }],
                },
              ]"
              :min="0"
              style="width: 80%"
            />
            <div style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center">元</div>
          </a-input-group>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="8">
        <a-form-item label="单程快递费" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
          <a-input-group compact>
            <a-input-number 
              v-decorator="[
                'expressPrice',
                {
                  rules: [{ required: true, message: '请输入' }],
                },
              ]"
              :min="0"
              style="width: 80%"
            />
            <div style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center">元</div>
          </a-input-group>
        </a-form-item>
      </a-col>
    </a-row>
    <a-form-item label="译文费" required>
      <a-button style="width:200px;float:right" @click="addYiWen({name: '译文费', type: 1})">
        <a-icon type="plus-circle" />
        添加收费类型
      </a-button>
    </a-form-item>
    <a-table
      class="queryView-table mt--10"
      :rowKey="useRowIndex"
      bordered
      :columns="tableColumns"
      :dataSource="translationDataSource"
      :pagination="false"
      size="middle"
    ></a-table>
    <a-form-item label="原译费 " required>
    </a-form-item>
    <div class="mt--20" style="padding:20px;border:1px solid #dfdfdf">
      <div style="margin-bottom:20px">
        <div>
          <span style="line-height:32px;font-weight:bold">证书（按件收费）</span>
          <a-button style="width:200px;float:right" @click="addYiWen({name: '原译费（证书）', type: 2})">
            <a-icon type="plus-circle" />
            添加收费类型
          </a-button>
        </div>
        <a-table
          class="queryView-table mt-2"
          :rowKey="useRowIndex"
          bordered
          :columns="tableColumns"
          :dataSource="certificateDataSource"
          :pagination="false"
          size="middle"
        ></a-table>
      </div>
      <div style="margin-bottom:20px">
        <div>
          <span style="line-height:32px;font-weight:bold">文书（按件收费）</span>
          <a-button style="width:200px;float:right" @click="addYiWen({name: '原译费（文书）', type: 3})">
            <a-icon type="plus-circle" />
            添加收费类型
          </a-button>
        </div>
        <a-table
          class="queryView-table mt-2"
          :rowKey="useRowIndex"
          bordered
          :columns="tableColumns"
          :dataSource="documentDataSource"
          :pagination="false"
          size="middle"
        ></a-table>
      </div>
      <div style="margin-bottom:20px">
        <div>
          <span style="line-height:32px;font-weight:bold">成绩单（按件收费）</span>
          <a-button style="width:200px;float:right" @click="addYiWen({name: '原译费（成绩单）', type: 4})">
            <a-icon type="plus-circle" />
            添加收费类型
          </a-button>
        </div>
        <a-table
          class="queryView-table mt-2"
          :rowKey="useRowIndex"
          bordered
          :columns="tableColumns"
          :dataSource="reportDataSource"
          :pagination="false"
          size="middle"
        ></a-table>
      </div>
      <div style="margin-bottom:20px">
        <div>
          <span style="line-height:32px;font-weight:bold">表格 ≤ 500字（按件收费）</span>
          <a-button style="width:200px;float:right" @click="addYiWen({name: '原译费（表格）', type: 5})">
            <a-icon type="plus-circle" />
            添加收费类型
          </a-button>
        </div>
        <a-table
          class="queryView-table mt-2"
          :rowKey="useRowIndex"
          bordered
          :columns="tableColumns"
          :dataSource="dataSource"
          :pagination="false"
          size="middle"
        ></a-table>
      </div>
      <div style="margin-bottom:20px">
        <div>
          <span style="line-height:32px;font-weight:bold">其他(出生证明等)（按件收费）</span>
          <a-button style="width:200px;float:right" @click="addYiWen({name: '原译费（其他）', type: 6})">
            <a-icon type="plus-circle" />
            添加其他类型
          </a-button>
        </div>
        <a-table
          class="queryView-table mt-2"
          :rowKey="useRowIndex"
          bordered
          :columns="tableColumns"
          :dataSource="outherDataSource"
          :pagination="false"
          size="middle"
        ></a-table>
      </div>
    </div>
    <a-row :gutter="24">
      <a-col :span="8">
        <a-form-item label="普通时长" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
          <a-input-group compact>
            <a-input 
              v-decorator="[
                'ordinaryDuration',
                {
                  rules: [{ required: true, message: '普通时长不能为空' }],
                },
              ]"
              placeholder="请输入普通时长"
            />
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="加急时长" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
          <a-input-group compact>
            <a-input 
              v-decorator="[
                'urgentDuration',
                {
                  rules: [{ required: true, message: '加急时长不能为空' }],
                },
              ]"
              placeholder="请输入加急时长"
            />
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="特级时长" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:90px' }">
          <a-input-group compact>
            <a-input 
              v-decorator="[
                'superDuration',
                {
                  rules: [{ required: true, message: '特级时长不能为空' }],
                },
              ]"
              placeholder="请输入特级时长"
            />
          </a-input-group>
        </a-form-item>
      </a-col>
    </a-row>
    <AddPro ref="addPro"></AddPro>
    <SetPrice ref="setPrice"></SetPrice>
    <SetNotarPriceType ref="setNotarPriceType"></SetNotarPriceType>
  </div>
</template>
<script>
import AddPro from './AddNotarPro.vue'
import SetPrice from './SetNotarPrice.vue'
import SetNotarPriceType from './SetNotarPriceType.vue'
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  props: {
    companyData: {
      type: Object,
      require: true
    },
    formData: {
      type: Object,
      require: true,
    },
  },
  components: {
    AddPro,
    SetPrice,
    SetNotarPriceType,
  },
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <div>{index + 1}</div>
        },
      },
      {
        title: '名称',
        width: '35%',
        align: 'center',
        dataIndex: 'infoName',
      },
      {
        title: '价格',
        width: '30%',
        align: 'center',
        dataIndex: 'infoPrice',
      },
      {
        title: '操作',
        width: '30%',
        align: 'center',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <a
                onClick={() => {
                  this.setPrice(row, index)
                }}
              >
                编辑
              </a>
              <app-icon
                type="icon-shanchu"
                onClick={() => {
                  this.removeRow(row, index)
                }}
              ></app-icon>
            </div>
          )
        },
      },
    ]
    return {
      tableColumns: tableColumns,
      translationDataSource: [],
      certificateDataSource: [],
      documentDataSource: [],
      reportDataSource: [],
      dataSource: [],
      outherDataSource: [],
    }
  },
  created() {
  },
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      if (this.companyData && this.companyData.baseId) {
        this.safeSetFieldsValue$t(this.formData, this.companyData)
        this.companyData.moreInfoList.forEach(element => {
          var objData = JSON.parse(JSON.stringify(element))
          objData.infoLanguage = JSON.parse(objData.infoLanguage)
          switch (objData.infoType) {
            case 1:
              this.translationDataSource.push(objData)
              break
            case 2:
              this.certificateDataSource.push(objData)
              break
            case 3:
              this.documentDataSource.push(objData)
              break
            case 4:
              this.reportDataSource.push(objData)
              break
            case 5:
              this.dataSource.push(objData)
              break
            case 6:
              this.outherDataSource.push(objData)
              break
          }
        })
      } else {
        setTimeout(() => {
          this.loadList()
        }, 100)
      }
    },
    getCompanyData() {
      if (this.companyData && this.companyData.baseId) {
        this.companyData.moreInfoList.forEach(element => {
          element.infoLanguage = JSON.parse(element.infoLanguage)
          switch (element.infoType) {
            case 1:
              this.translationDataSource.push(element)
              break
            case 2:
              this.certificateDataSource.push(element)
              break
            case 3:
              this.documentDataSource.push(element)
              break
            case 4:
              this.reportDataSource.push(element)
              break
            case 5:
              this.dataSource.push(element)
              break
            case 6:
              this.outherDataSource.push(element)
              break
          }
        })
      }
    },
    async addYiWen(obj) {
      const object = await this.$refs.setNotarPriceType.start(obj)
      if (object) {
        switch (obj.type) {
          case 1:
            this.translationDataSource.push(object)
            break
          case 2:
            this.certificateDataSource.push(object)
            break
          case 3:
            this.documentDataSource.push(object)
            break
          case 4:
            this.reportDataSource.push(object)
            break
          case 5:
            this.dataSource.push(object)
            break
          case 6:
            this.outherDataSource.push(object)
            break
        }
      }
    },
    async removeRow(row, index) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      switch (row.infoType) {
        case 1:
          this.translationDataSource.splice(index, 1)
          break
        case 2:
          this.certificateDataSource.splice(index, 1)
          break
        case 3:
          this.documentDataSource.splice(index, 1)
          break
        case 4:
          this.reportDataSource.splice(index, 1)
          break
        case 5:
          this.dataSource.splice(index, 1)
          break
        case 6:
          this.outherDataSource.splice(index, 1)
          break
      }
      this.$message.success('操作成功!')
    },
    getList() {
      return [...this.translationDataSource, ...this.certificateDataSource, ...this.documentDataSource, ...this.reportDataSource, ...this.dataSource, ...this.outherDataSource]
    },
    validateList() {
      if (!this.translationDataSource || this.translationDataSource.length <= 0) {
        this.$message.error('译文费不能为空!')
        return true
      }
      if (!this.certificateDataSource || this.certificateDataSource.length <= 0) {
        this.$message.error('原译费（证书）不能为空!')
        return true
      }
      if (!this.documentDataSource || this.documentDataSource.length <= 0) {
        this.$message.error('原译费（文书）不能为空!')
        return true
      }
      if (!this.reportDataSource || this.reportDataSource.length <= 0) {
        this.$message.error('原译费（成绩单）不能为空!')
        return true
      }
      if (!this.dataSource || this.dataSource.length <= 0) {
        this.$message.error('原译费（表格）不能为空!')
        return true
      }
      if (!this.outherDataSource || this.outherDataSource.length <= 0) {
        this.$message.error('原译费（其他）不能为空!')
        return true
      }
    },
    async setPrice(row, index) {
      const obj = {
        name: row.infoType === 1?'译文费':row.infoType === 2?'原译费（证书）':row.infoType === 3?'原译费（文书）':row.infoType === 4?'原译费（成绩单）':row.infoType === 5?'原译费（表格）':row.infoType === 5?'原译费（其他）':'-',
        type: row.infoType
      }
      const object = await this.$refs.setNotarPriceType.start(obj, row)
      if (object) {
        console.log(object)
        switch (row.infoType) {
          case 1:
            this.translationDataSource[index].infoLanguage = object.infoLanguage
            this.translationDataSource[index].infoName = object.infoName
            this.translationDataSource[index].infoPrice = object.infoPrice
            this.translationDataSource[index].infoSpeed = object.infoSpeed
            break
          case 2:
            this.certificateDataSource[index].infoLanguage = object.infoLanguage
            this.certificateDataSource[index].infoName = object.infoName
            this.certificateDataSource[index].infoPrice = object.infoPrice
            this.certificateDataSource[index].infoSpeed = object.infoSpeed
            break
          case 3:
            this.documentDataSource[index].infoLanguage = object.infoLanguage
            this.documentDataSource[index].infoName = object.infoName
            this.documentDataSource[index].infoPrice = object.infoPrice
            this.documentDataSource[index].infoSpeed = object.infoSpeed
            break
          case 4:
            this.reportDataSource[index].infoLanguage = object.infoLanguage
            this.reportDataSource[index].infoEducation = object.infoEducation
            this.reportDataSource[index].infoName = object.infoName
            this.reportDataSource[index].infoPrice = object.infoPrice
            this.reportDataSource[index].infoSpeed = object.infoSpeed
            break
          case 5:
            this.dataSource[index].infoLanguage = object.infoLanguage
            this.dataSource[index].infoName = object.infoName
            this.dataSource[index].infoPrice = object.infoPrice
            this.dataSource[index].infoSpeed = object.infoSpeed
            break
          case 6:
            this.outherDataSource[index].infoLanguage = object.infoLanguage
            this.outherDataSource[index].infoName = object.infoName
            this.outherDataSource[index].infoPrice = object.infoPrice
            this.outherDataSource[index].infoSpeed = object.infoSpeed
            break
        }
      }
    },
  }
}
</script>
<style lang="less" scoped>
  .mt--10{
    margin-top: -14px;
    margin-bottom: 24px;
  }
  .mt--20{
    margin-top: -24px;
    margin-bottom: 24px;
  }
</style>
